// extracted by mini-css-extract-plugin
module.exports = {"Emergency":"Emergency_Emergency__dlBu6"};